import script from "./Point.vue?vue&type=script&setup=true&lang=ts"
export * from "./Point.vue?vue&type=script&setup=true&lang=ts"

import "./Point.vue?vue&type=style&index=0&id=58e5ca9d&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e5ca9d"]])

export default __exports__